import { render, staticRenderFns } from "./EmployeeAvatar.vue?vue&type=template&id=08f57a9d&scoped=true&"
import script from "./EmployeeAvatar.vue?vue&type=script&lang=ts&"
export * from "./EmployeeAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeAvatar.vue?vue&type=style&index=0&id=08f57a9d&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f57a9d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VIcon,VImg})
